// extracted by mini-css-extract-plugin
module.exports = {"backButton":"PdpBreadcrumb_backButton__T0j4Z","container":"PdpBreadcrumb_container__0iLMC"};